import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {
  RegionInformationRestService
} from '../../../../shared/services/nso-data-portal/rest-services/region-information-rest.service';
import {WorldInformationRestService} from '../../../../shared/services/nso-data-portal/rest-services/world-information-rest.service';
import {SearchEntityLevels} from '../../../../shared/types/nso-data-portal/search-entity-levels';

@Component({
  selector: 'wsd-constitution-region-world',
  templateUrl: './constitution-region-world.component.html',
  styleUrls: ['./constitution-region-world.component.css']
})
export class ConstitutionRegionWorldComponent implements OnChanges {

  percentage: number;

  @Input()
  entityId: number;

  @Input()
  entityLevel: string;

  constructor(private regionRest: RegionInformationRestService,
              private worldRest: WorldInformationRestService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.entityLevel === SearchEntityLevels.REGION) {
      this.regionRest.getConstitutionInformation(this.entityId).subscribe(
        res => this.percentage = res
      );
    } else {
      this.worldRest.getConstitutionInformation().subscribe(
        res => this.percentage = res
      );
    }
  }

}
